import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const isSalesLeaderDefinition = definitionFactory({
  key: 'is_sales_leader',
  mapper: (jsonQueryValue, tags, state) => {
    return [
      {
        label: 'Лидер продаж',
        value: jsonQueryValue,
      },
    ];
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'is_sales_leader', options);
  },
});
